<template>
  <TextField :value="value" :name="name" type="url" :rules="rules" :max="500" noCounter @input="onInput"/>
</template>

<script>
import TextField from "@/components/atoms/TextField";
import ComponentMixin from "@/components/ComponentMixin";
export default {
  mixins: [ComponentMixin],
  type: "molecule",
  name: "UrlField",
  components: {TextField},
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: String | null,
      required: true
    }
  },
  computed: {
    rules () {
      return [
        (value) => {
          if (value && !value.match(/^https?:\/\//)) {
            return this.error('invalidUrl');
          }
          return true;
        }
      ]
    }
  },
  methods: {
    onInput (value) {
      this.$emit("input", value);
    }
  }
}
</script>

<style scoped>

</style>
